import RequestHandler from "./request-handler";
class HotWaterTableHeaderService {
    constructor() {
        this.path = "HotWaterTableHeader";
        if (HotWaterTableHeaderService.instance) {
            return HotWaterTableHeaderService.instance;
        }
        HotWaterTableHeaderService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async getById(id) {
        return await RequestHandler.getById(this.path, id);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async import(data) {
        return await RequestHandler.import(this.path, data);
    }
}
const instance = new HotWaterTableHeaderService();
export default instance;